"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./pathwayPrerequisites.scss");
const PathwayPrerequisites = ({ automationRules, }) => {
    const renderAutomationRule = (rule, depth = 0) => {
        const { or, and, campaign } = rule;
        // Base case: if this is a leaf node (no and/or arrays), render the campaign
        if ((!and || and.length === 0) && (!or || or.length === 0)) {
            return (react_1.default.createElement("span", { className: "prerequisite-campaign-text" }, (campaign === null || campaign === void 0 ? void 0 : campaign.title) || "No campaign"));
        }
        // Handle AND logic
        if (and && and.length > 0) {
            return (react_1.default.createElement("div", { className: `prerequisite-group prerequisite-and-group depth-${depth}` }, and.map((andRule, index) => (react_1.default.createElement(react_1.default.Fragment, { key: `and-${depth}-${index}` },
                renderAutomationRule(andRule, depth + 1),
                index < and.length - 1 && (react_1.default.createElement("span", { className: "prerequisite-operator and-operator" }, "And")))))));
        }
        // Handle OR logic
        if (or && or.length > 0) {
            return (react_1.default.createElement("div", { className: `prerequisite-group prerequisite-or-group depth-${depth}` }, or.map((orRule, index) => {
                return (react_1.default.createElement(react_1.default.Fragment, { key: `or-${depth}-${index}` },
                    renderAutomationRule(orRule, depth + 1),
                    index < or.length - 1 && (react_1.default.createElement("div", { className: "prerequisite-operator or-operator" }, "OR"))));
            })));
        }
        // Fallback - should not reach here if data is properly structured
        return (react_1.default.createElement("span", { className: "prerequisite-campaign" }, (campaign === null || campaign === void 0 ? void 0 : campaign.title) || "No campaign"));
    };
    const renderAutomationRules = (rules) => {
        const { or } = rules;
        if (!or || or.length === 0) {
            return (react_1.default.createElement("span", { className: "prerequisite-empty" }, "No prerequisites defined"));
        }
        return (react_1.default.createElement("div", { className: "prerequisite-rules-container" }, or.map((rule, index) => (react_1.default.createElement(react_1.default.Fragment, { key: `rule-${index}` },
            renderAutomationRule(rule, 0),
            index < or.length - 1 && (react_1.default.createElement("div", { className: "prerequisite-operator or-operator" }, "OR")))))));
    };
    return (react_1.default.createElement("div", { className: "pathway-prerequisites" },
        react_1.default.createElement("h3", { className: "prerequisites-title" }, "Prerequisites"),
        react_1.default.createElement("div", { className: "prerequisites-content" }, renderAutomationRules(automationRules))));
};
exports.default = PathwayPrerequisites;
